function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Step 02 Copy");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#5F1FFC",
  d: "M118 82h472v372H118z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#EEF4FF",
  d: "M159.6 128.4h512v360h-512z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M250 202h284v64H250z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#EAF0F9",
  strokeWidth: 0.8,
  strokeOpacity: 0.824,
  d: "M250.4 202.4h283.2v63.2H250.4z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#5F1FFC",
  d: "M250 370h284v64H250z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#EEF4FF",
  strokeWidth: 0.8,
  d: "M250.4 370.4h283.2v63.2H250.4z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M250 286h284v64H250z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#EAF0F9",
  strokeWidth: 0.8,
  strokeOpacity: 0.824,
  d: "M250.4 286.4h283.2v63.2H250.4z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#FFF",
  d: "M250 454h284v64H250z"
}), React.createElement("path", {
  fill: "none",
  stroke: "#EEF4FF",
  strokeWidth: 1.6,
  d: "M250.8 454.8h282.4v62.4H250.8z"
}));

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.904
}, React.createElement("path", {
  d: "M662 150h20v284h-20z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M672.4 165.91c2.209 0 4-1.781 4-3.978s-1.791-3.978-4-3.978-4 1.781-4 3.978 1.791 3.978 4 3.978z"
}));

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(250 169.2)"
}, React.createElement("circle", {
  fill: "#5F1FFB",
  cx: 5.2,
  cy: 5.2,
  r: 5.2
}), React.createElement("circle", {
  fill: "#5F1FFB",
  cx: 28.4,
  cy: 5.2,
  r: 5.2
}), React.createElement("circle", {
  fill: "#5F1FFB",
  cx: 51.6,
  cy: 5.2,
  r: 5.2
}), React.createElement("circle", {
  fill: "#FFF",
  cx: 74.8,
  cy: 5.2,
  r: 5.2
}), React.createElement("circle", {
  fill: "#FFF",
  cx: 98,
  cy: 5.2,
  r: 5.2
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 564,
    height: 436,
    viewBox: "118 82 564 436"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

export default __webpack_public_path__ + "static/media/howitworks_2.15a52c2c.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/containers/static/landing/howitworks_2.svg
// module id = 394
// module chunks = 0